import { Button, Center, Icon, Text } from 'native-base'
import { WarningCircle } from 'phosphor-react-native'
import React, { PropsWithChildren } from 'react'
import { ErrorBoundary as ReactErrorBoundary, FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { Platform } from 'react-native'
import * as Sentry from 'sentry-expo'

import { restartApp } from '../../util/restart'

const ErrorFallback: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation()
  return (
    <Center alignItems="center" minHeight="full">
      <Icon as={<WarningCircle color="currentColor" />} size="3xl" color="primary.500" />
      <Text fontSize="xl" bold mt={7}>
        {t('errorBoundary.heading')}
      </Text>
      <Text fontSize="md" mt={4}>
        {t('errorBoundary.text')}
      </Text>
      <Button size="sm" mt={5} onPress={resetErrorBoundary}>
        {t('errorBoundary.button')}
      </Button>
    </Center>
  )
}

export const ErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    // TODO replace ReactErrorBoundary with Sentry.ErrorBoundary when we upgrade sentry-expo (note that to upgrade
    //  sentry-expo we need to upgrade the Expo SDK first).
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={restartApp}
      onError={error => {
        if (Platform.OS === 'web') {
          Sentry.Browser.captureException(error)
        } else {
          Sentry.Native.captureException(error)
        }
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
